export default {
  /** 对象处理 */
  dealObjectValue(obj) {
    var param = {}
    if (obj === null || obj === undefined || obj === '') return param
    for (var key in obj) {
      if (this.dataType(obj[key]) === 'Object') {
        param[key] = this.dealObjectValue(obj[key])
      } else if (obj[key] !== null && obj[key] !== undefined && obj[key] !== '') {
        param[key] = obj[key]
      }
    }
    return param
  },
  dataType(obj) {
    if (obj === null) return 'Null'
    if (obj === undefined) return 'Undefined'
    return Object.prototype.toString.call(obj).slice(8, -1)
  }
}
